// extracted by mini-css-extract-plugin
export default {"wrapper":"Thumbnail_wrapper__a36Rk","closeButton":"Thumbnail_closeButton__AFJYF","orientationButton":"Thumbnail_orientationButton__cyXYF","image":"Thumbnail_image__ucHEX"};